import {Avatar, Card, Text, DrawerHeader, DrawerHeaderTitle, OverlayDrawer, Spinner, Divider, DrawerBody,Button} from "@fluentui/react-components";
import {AlertFilled, ArrowLeftRegular, ArrowRightRegular} from "@fluentui/react-icons";
import React, {Fragment, useContext, useEffect, useRef, useState} from "react";
import {useBottomScrollListener} from "react-bottom-scroll-listener";
import {CCMNotificationModes} from "../constants/CCMNotificationModes";
import {MainContentViews} from "../constants/MainContentViews";
import AuthenticationController from "../controller/AuthenticationController";
import ContentController from "../controller/ContentController";
import EventController from "../controller/EventController";
import SessionController from "../controller/SessionController";
import Content from "../domain/Content";
import AuthenticationRequest from "../domain/endpoint/AuthenticationRequest";
import AuthenticationResponse from "../domain/endpoint/AuthenticationResponse";
import ContentPageResponse from "../domain/endpoint/ContentPageResponse";
import EventRequest from "../domain/endpoint/EventRequest";
import {RequestActionsConstant} from "../domain/endpoint/RequestActionsConstant";
import {ResponseStatusCodeConstants} from "../domain/endpoint/ResponseStatusCodeConstants";
import SessionResponse from "../domain/endpoint/SessionResponse";
import EventMessage from "../domain/EventMesssage";
import {EventType} from "../domain/EventType";
import Organization from "../domain/Organization";
import {TabViews} from "../domain/TabViews";
import ViewInfo, {ViewInfoViews} from "../domain/ViewInfo";
import {TeamsFxContext} from "./Context";
import Newsfeed from "./Newsfeed";
import Notifications from "./Notifications";
import Search from "./Search";
import TopBar from "./TopBar";

export default function Tab() {
    const {teamsUserCredential} = useContext(TeamsFxContext);
    const _numToIncrement: number = 5;
    const _sessionResponse = useRef<SessionResponse>(new SessionResponse());
    const _authenticateResponse = useRef<AuthenticationResponse>(new AuthenticationResponse());
    const selectedOrganization = useRef<Organization | undefined>(undefined);


    const [organizations, setOrganizations] = useState<Organization[]>([]);
    const [newsfeedViewInfo, setNewsfeedViewInfo] = useState<ViewInfo>(new ViewInfo(ViewInfoViews.NEWSFEED, RequestActionsConstant.GET_NEWSFEED));
    const [notificationViewInfo, setNotificationViewInfo] = useState<ViewInfo>(new ViewInfo(ViewInfoViews.NOTIICATION, RequestActionsConstant.GET_NOTIFICATION));
    const [searchViewInfo, setSearchViewInfo] = useState<ViewInfo>(new ViewInfo(ViewInfoViews.SEARCH, RequestActionsConstant.GET_SEARCH));
    const [isSwitchOrganizationOpen, setIsSwitchOrganizationOpen] = useState<boolean>(false);
    const [isNotificationOpen, setIsNotificationOpen] = useState<boolean>(false);
    const [currentView, setCurrentView] = useState<TabViews>(TabViews.LOADING);
    const [mainContentView, setMainContentView] = useState<MainContentViews>(MainContentViews.NewsfeedResults);

    function onHitBottom (){
        if (currentView === TabViews.FULL) {
            if (mainContentView === MainContentViews.NewsfeedResults) {
                showMoreItems(newsfeedViewInfo);
            } else {
                showMoreItems(searchViewInfo);
            }

        }
    }

    function onHitBottomNotifications(){
        if (currentView === TabViews.FULL) {
            showMoreItems(notificationViewInfo);
        }
    }

    const notificationScrollRef = useBottomScrollListener(onHitBottomNotifications, {offset: 80});

    useBottomScrollListener(onHitBottom, {offset: 80})

    useEffect(() => {
        if (!teamsUserCredential) {
            throw new Error("TeamsFx SDK is not initialized.");
        }

        teamsUserCredential?.getToken("").then((ssoData) => {
            getSession(ssoData?.token ?? "")
        });

    }, [])


    function processViewToDisplay(statusCode: number) {
        let _currentView = TabViews.UNKNOWN_ERROR;
        if (statusCode === ResponseStatusCodeConstants.REQUIRE_CONSENT) {
            _currentView = TabViews.REQUIRE_CONSENT;
        } else if (statusCode === ResponseStatusCodeConstants.NO_EMAIL) {
            _currentView = TabViews.USER_DOES_NOT_HAVE_EMAIL;
        } else if (statusCode === ResponseStatusCodeConstants.NO_ORGANIZATION ||
            statusCode === ResponseStatusCodeConstants.USER_NOT_EXISTS
        ) {
            _currentView = TabViews.USER_NOT_IN_SYSTEM_ORG_NOT_SUPPORT_TEAMS;
        }

        setCurrentView(_currentView);
    }

    async function getSession(token: string, enforceNewSession = false) {
        //setCurrentView(TabViews.LOADING);

        // if we dont have bnstoken we cant create a cross comm session; attempt to get one with the client token
        if (!_authenticateResponse?.current || !_authenticateResponse.current?.bnsToken) {
            teamsUserCredential?.getUserInfo().then(async (userInfo) => {
                const tenantId = userInfo?.tenantId;
                if (!tenantId) {
                    console.log('bc_code1', userInfo);
                    return;
                }
                try {
                    // call to exchange the client token
                    const res: AuthenticationResponse = await AuthenticationController.authenticate(new AuthenticationRequest(token, tenantId));
                    // was able to use the token to exchange for access token
                    if (res && res.statusCode && res.statusCode === ResponseStatusCodeConstants.SUCCESS) {
                        _authenticateResponse.current = res;
                        // then we call the function again to actually start a session with broadcast
                        getSession(res.bnsToken);

                    } else {

                        // if it wasn't success, it might be asking for additional one-time consent or display errors base on the return
                        processViewToDisplay((!res || !res.statusCode) ? ResponseStatusCodeConstants.UNKNOWN_ERROR : res.statusCode);
                    }
                } catch (err: any) {
                    // any other error we will just display unknown error
                    processViewToDisplay(ResponseStatusCodeConstants.UNKNOWN_ERROR);

                }
            }).catch((err: any) => {
                processViewToDisplay(ResponseStatusCodeConstants.UNKNOWN_ERROR);
            });



        } else if (token === _authenticateResponse.current?.bnsToken) {

            const selectedOrganizationId = selectedOrganization.current ? selectedOrganization.current?.organizationId : null;
            SessionController.getSession(_authenticateResponse.current.authenticateUser, _authenticateResponse.current.bnsToken, selectedOrganizationId, enforceNewSession)
                .then((sessionResponse: SessionResponse) => {
                    if (sessionResponse && sessionResponse.statusCode && sessionResponse.statusCode === ResponseStatusCodeConstants.SUCCESS) {
                        initializeInitialSessionSuccessState(sessionResponse);

                    } else {
                        processViewToDisplay((!sessionResponse || !sessionResponse.statusCode) ? ResponseStatusCodeConstants.UNKNOWN_ERROR : sessionResponse.statusCode);
                    }
                })
                .catch((err: any) => {

                    processViewToDisplay((!err || !err.statusCode) ? ResponseStatusCodeConstants.UNKNOWN_ERROR : err.statusCode);

                });

        } else {

            processViewToDisplay(ResponseStatusCodeConstants.UNKNOWN_ERROR);

        }
    }

    function initializeInitialSessionSuccessState(sessionResponse: SessionResponse) {
        const newsfeedViewInfo: ViewInfo = new ViewInfo(ViewInfoViews.NEWSFEED, RequestActionsConstant.GET_NEWSFEED);
        const notificationViewInfo: ViewInfo = new ViewInfo(ViewInfoViews.NOTIICATION, RequestActionsConstant.GET_NOTIFICATION);
        const organizations: Organization[] = sessionResponse.organizations;
        const _selectedOrganization: Organization | undefined = organizations.find(org => org.organizationId === sessionResponse.selectedOrganizationId);

        _sessionResponse.current = sessionResponse;

        if (sessionResponse.newsfeedPage1 && sessionResponse.newsfeedPage1.statusCode === ResponseStatusCodeConstants.SUCCESS) {
            const newsfeedContentResponse: ContentPageResponse = sessionResponse.newsfeedPage1;
            newsfeedViewInfo.itemsPool = newsfeedContentResponse.contents || [];
            newsfeedViewInfo.lastPagePagination = newsfeedContentResponse.pagination;
        }

        if (sessionResponse.notificationPage1 && sessionResponse.notificationPage1.statusCode === ResponseStatusCodeConstants.SUCCESS) {
            const notificationContentResponse: ContentPageResponse = sessionResponse.notificationPage1;
            notificationViewInfo.itemsPool = notificationContentResponse.contents || [];
            notificationViewInfo.lastPagePagination = notificationContentResponse.pagination;
        }

        syncDisplayItems(newsfeedViewInfo);
        syncDisplayItems(notificationViewInfo);
        setOrganizations(organizations);
        selectedOrganization.current = _selectedOrganization;
        setCurrentView(TabViews.FULL);
    }

    function syncDisplayItems(viewInfo: ViewInfo) {

        const numToGrab = viewInfo.numItemToDisplay - viewInfo.itemsToDisplay.length;
        const itemsGrabbed: Content[] = viewInfo.itemsPool.splice(0, numToGrab);
        if (itemsGrabbed.length > 0) {
            viewInfo.itemsToDisplay = viewInfo.itemsToDisplay.concat(itemsGrabbed);
            if (viewInfo.viewId === ViewInfoViews.NOTIICATION) {
                if (isNotificationOpen) {
                    sendImpressions(itemsGrabbed);
                }

            } else {
                sendImpressions(itemsGrabbed);
            }
            updateViewInfoState(viewInfo);
        }


        if (viewInfo.itemsPool.length <= 10 && viewInfo.lastPagePagination && viewInfo.lastPagePagination.hasMore && !viewInfo.isPreloading) {
            preloadMoreContent(viewInfo);
        }

    }

    function updateViewInfoState(viewInfo: ViewInfo) {
        if (viewInfo.viewId === ViewInfoViews.NEWSFEED) {
            setNewsfeedViewInfo({...viewInfo});
        } else if (viewInfo.viewId === ViewInfoViews.NOTIICATION) {
            setNotificationViewInfo({...viewInfo});
        } else if (viewInfo.viewId === ViewInfoViews.SEARCH) {
            setSearchViewInfo({...viewInfo});
        }
    }

    function sendImpressions(contents: Content[]) {
        if (!contents || contents.length <= 0) {
            return;
        }

        // break into chunks of 20 contents
        const contentChunks: Content[][] = [];
        const chunkSize = 20;
        for (let i = 0; i < contents.length; i += chunkSize) {
            contentChunks.push(contents.slice(0, i + chunkSize));
        }

        // loop through each chunk
        contentChunks.forEach((contentChunk: Content[]) => {
            const eventMessages: EventMessage[] = contentChunk.map((curItem: Content) => {
                return new EventMessage(_sessionResponse.current?.crossCommSession, curItem, EventType.IMPRESSION);
            });
            const eventRequest = new EventRequest(_sessionResponse.current?.crossCommSession, _sessionResponse.current?.teamsToken, eventMessages);
            // send off the impression events
            EventController.sendEvent(eventRequest)
                .then(() => {
                    // do nothing
                }).catch(() => {
                // do nothing
            });
        });
    }


    function preloadMoreContent(viewInfo: ViewInfo) {
        if (!(_sessionResponse.current &&
            _sessionResponse.current.crossCommSession &&
            _sessionResponse.current.crossCommSession.id &&
            _sessionResponse.current.crossCommSession.id > 0 &&
            _sessionResponse.current.teamsToken &&
            _sessionResponse.current.teamsToken.length > 0)) {
            return;
        }

        if (viewInfo.isPreloading || (viewInfo.lastPagePagination && !viewInfo.lastPagePagination.hasMore)) {
            return;
        }

        viewInfo.isPreloading = true;

        updateViewInfoState(viewInfo);

        ContentController.getContent(_sessionResponse.current.crossCommSession, _sessionResponse.current.teamsToken, viewInfo.action, viewInfo.lastPagePagination.page + 1, viewInfo.searchText).then((data: ContentPageResponse) => {
            if (!data || !data.statusCode ||
                data.statusCode !== ResponseStatusCodeConstants.SUCCESS ||
                !data.pagination ||
                !data.pagination.page
            ) {
                return;
            }

            const isLoadedNewPage = !viewInfo.lastPagePagination || viewInfo.lastPagePagination.page < data.pagination.page;
            const hasNewData = data.contents && data.contents.length > 0;

            // the page we loaded wasnt greater than the previous
            if (!isLoadedNewPage) {
                return;
            }

            viewInfo.lastPagePagination = data.pagination;

            // if no data, we just set the pagination then exit out
            if (!hasNewData) {
                updateViewInfoState(viewInfo);
                return;
            }

            data.contents.forEach((curItem: Content) => {

                let isFound = viewInfo.itemsToDisplay.find(
                    (curItem2: Content) => {
                        return curItem2.postId === curItem.postId;
                    }
                );
                isFound = isFound || viewInfo.itemsPool.find(
                    (curItem2: Content) => {
                        return curItem2.postId === curItem.postId;
                    }
                );

                if (!isFound) {
                    viewInfo.itemsPool.push(curItem);
                }
            });
            syncDisplayItems(viewInfo);
        }).then(() => {
            viewInfo.isPreloading = false;
            updateViewInfoState(viewInfo);
        }).catch((err) => {
            console.log(err);
        });
    }

    function handleNotificationClick() {

        const _isNotificationOpen: boolean = !isNotificationOpen;
        handleBodyNoScroll(_isNotificationOpen);
        const _notificationViewInfo = notificationViewInfo;
        if (isNotificationOpen && selectedOrganization.current && selectedOrganization.current.ccmNotificationMode !== CCMNotificationModes.CLEAR_ON_ACTION) {
            _notificationViewInfo.itemsToDisplay.forEach((curItem: Content) => {
                curItem.hasNotificationImpression = true;
            });
        }

        setIsNotificationOpen(_isNotificationOpen);
        setIsSwitchOrganizationOpen(_isNotificationOpen ? false : isSwitchOrganizationOpen);
        updateViewInfoState(_notificationViewInfo);

    }

    function handleBodyNoScroll(isDrawerOpen: boolean) {

        if (isDrawerOpen) {
            document.body.classList.add("no-scroll");
        } else {
            document.body.classList.remove("no-scroll");
        }

    }


    function handleSearchStateChange(isSearchOpen: boolean) {
        if (isSearchOpen) {
            setIsSwitchOrganizationOpen(false);
            setIsNotificationOpen(false);
            setMainContentView(MainContentViews.SearchResults);
        } else {
            const searchViewInfo = new ViewInfo(ViewInfoViews.SEARCH, RequestActionsConstant.GET_SEARCH);
            setMainContentView(MainContentViews.NewsfeedResults);
            setSearchViewInfo(searchViewInfo);
        }

    }


    function handleSwitchOrganizationClick() {
        const _isSwitchOrganizationOpen: boolean = !isSwitchOrganizationOpen;
        setIsSwitchOrganizationOpen(_isSwitchOrganizationOpen);
        handleBodyNoScroll(_isSwitchOrganizationOpen);
        if (_isSwitchOrganizationOpen) {
            setIsNotificationOpen(false);
        }
    }

    function handleReadMore (content: Content){
        if (!content || !content.contentLink || !_sessionResponse.current || !_sessionResponse.current.crossCommSession) {
            return;
        }
        const eventMessages: EventMessage[] = [];
        const eventMessage = new EventMessage(_sessionResponse.current.crossCommSession, content, EventType.CLICK);
        eventMessages.push(eventMessage);

        EventController.sendEvent(new EventRequest(_sessionResponse.current.crossCommSession, _sessionResponse.current.teamsToken, eventMessages));

        seekAndUpdateClickOrDismiss(content, true);

        window.open(content.contentLink, "_blank");
    }

    function seekAndUpdateClickOrDismiss(content: Content, isClicked: boolean) {
        if (!content) {
            return;
        }

        const _notificationViewInfo = notificationViewInfo;
        const _newsfeedViewInfo = newsfeedViewInfo;
        const _searchViewInfo = searchViewInfo;
        const allViewInfos: ViewInfo[] = [_notificationViewInfo, _newsfeedViewInfo, _searchViewInfo];

        allViewInfos.forEach((currentViewInfo: ViewInfo) => {
            if (!currentViewInfo) {
                return;
            }

            let foundItem = currentViewInfo.itemsToDisplay.find((curItem: Content) => {
                return curItem.postId === content.postId;
            });
            if (!foundItem) {
                foundItem = currentViewInfo.itemsPool.find((curItem: Content) => {
                    return curItem.postId === content.postId;
                });
            }
            if (foundItem) {
                if (isClicked) {
                    foundItem.isClicked = true;
                } else {
                    foundItem.isDismissed = true;
                }

            }
        });

        updateViewInfoState(_notificationViewInfo);
        updateViewInfoState(_newsfeedViewInfo);
        updateViewInfoState(_searchViewInfo);
    }

    function handleDismiss  (content: Content) {
        if (!content || !content.contentLink || !_sessionResponse || !_sessionResponse.current.crossCommSession) {
            return;
        }
        const eventMessages: EventMessage[] = [];
        const eventMessage = new EventMessage(_sessionResponse.current.crossCommSession, content, EventType.DISMISS);
        eventMessages.push(eventMessage);

        EventController.sendEvent(new EventRequest(_sessionResponse.current.crossCommSession, _sessionResponse.current.teamsToken, eventMessages));

        seekAndUpdateClickOrDismiss(content, false);

    }

    function handleSearchOnSubmit (searchText: string){
        if (!searchText || searchText.trim().length <= 0 || searchText.trim().toLowerCase() === searchViewInfo.searchText.trim().toLowerCase() ) {
            return;
        }
        const _searchViewInfo = new ViewInfo(ViewInfoViews.SEARCH, RequestActionsConstant.GET_SEARCH);
        _searchViewInfo.searchText = searchText.trim();
        syncDisplayItems(_searchViewInfo);
    }

    function handleSelectedOrganizationClick (organization: Organization) {
        if (!organization) {
            return;
        }
        if (organization.organizationId === selectedOrganization.current?.organizationId) {
            handleSwitchOrganizationClick();
            return;
        }

        //setCurrentView(TabViews.LOADING);
        selectedOrganization.current = organization;
        handleSwitchOrganizationClick();
        getSession(_authenticateResponse.current.bnsToken);
    }

    function  renderSwitchOrganizationDrawer() {
        let switchOrganizationDrawer = <></>;
        let switchOrganizationItems  = [];
        if (organizations && organizations.length > 0) {
            switchOrganizationItems = organizations.map((curItem: Organization) => {

                return (
                    <Card key={curItem.organizationId} selected={curItem.organizationId === selectedOrganization.current?.organizationId} style={{cursor: "pointer"}} onClick={() => {handleSelectedOrganizationClick(curItem); } }>
                        <div className="smt-flex smt-flex__gap-2 smt-flex__ai-center">
                            <Avatar size={32} image={{ src: curItem.organizationIcon }}  />
                            <Text weight="semibold">{curItem.organizationName}</Text>
                        </div>
                    </Card>
                );
            });
            switchOrganizationDrawer = (
                <OverlayDrawer open={isSwitchOrganizationOpen} onOpenChange={() => { handleSwitchOrganizationClick(); }}>
                    <DrawerHeader>
                        <DrawerHeaderTitle action={<Button appearance="subtle" icon={<ArrowLeftRegular />} onClick={() => setIsSwitchOrganizationOpen(false)}/> }>Select Organization</DrawerHeaderTitle>
                    </DrawerHeader>
                    <DrawerBody>
                        <div className="smt-flex smt-flex__dir_column smt-flex__gap-1">
                            <Divider />
                            {switchOrganizationItems}
                        </div>
                    </DrawerBody>
                </OverlayDrawer>
            );
        }
        return switchOrganizationDrawer;
    }

    function handleRefreshNewsfeed (){
        if (!_authenticateResponse || !_authenticateResponse?.current?.bnsToken) {
            return;
        }
        getSession(_authenticateResponse.current.bnsToken, true);
    }

    function showMoreItems(viewInfo: ViewInfo) {
        if (!(viewInfo.viewId in ViewInfoViews)) {
            return;
        }

        if (viewInfo.numItemToDisplay === viewInfo.itemsToDisplay.length)  {
            viewInfo.numItemToDisplay += _numToIncrement;
        }
        if (viewInfo.itemsPool.length === 0 && viewInfo.isPreloading) {
            return;
        }
        syncDisplayItems(viewInfo);
    }

    function handleConsentClick (){
        teamsUserCredential!.login(["User.Read"]).then(() => {
            window.location.reload();
        }).catch(() => {
            processViewToDisplay(ResponseStatusCodeConstants.UNKNOWN_ERROR);
        })
    }
    function renderNotificationDrawer() {
        const newNotifications: Content[] = [];
        const previousNotifications: Content[] = [];

        if (notificationViewInfo?.itemsToDisplay.length > 0) {
            if (isNotificationOpen) {
                sendImpressions(notificationViewInfo.itemsToDisplay);
            }
            notificationViewInfo.itemsToDisplay.forEach((currentItem) => {
                if (currentItem.isNewNotification) {
                    newNotifications.push(currentItem);
                } else {
                    previousNotifications.push(currentItem);
                }
            });
        }


        return (
            <OverlayDrawer
                    style={{width: "100%", maxWidth:"380px"}}
                    position="end"
                    open={isNotificationOpen}
                    onOpenChange={() => { handleNotificationClick(); }}>
            <DrawerHeader>
                <DrawerHeaderTitle action={<Button appearance="subtle" icon={<ArrowRightRegular />} onClick={handleNotificationClick}/> }>
                    <div className="smt-flex smt-flex__ai-center smt-flex__gap-1"><AlertFilled /><span>Notifications</span></div>
                </DrawerHeaderTitle>
            </DrawerHeader>
            <DrawerBody ref={notificationScrollRef as React.RefObject<HTMLDivElement>}>
                <div className="smt-flex smt-flex__dir_column" style={{marginTop: "24px"}}>
                    <Notifications
                        organizationName={selectedOrganization.current?.organizationName}
                        onReadMore={handleReadMore}
                        onDismiss={handleDismiss}
                        newNotifications={newNotifications}
                        previousNotifications={previousNotifications}
                    />
                </div>
            </DrawerBody>
        </OverlayDrawer>);
    }


    function render() {
        let currentViewRender = (<Fragment></Fragment>);

        if (currentView === TabViews.FULL) {
            currentViewRender = (
                <Fragment>
                    <TopBar
                        organizations={organizations}
                        selected={selectedOrganization.current}
                        onClickNotificationIcon={handleNotificationClick}
                        onClickSwitchOrganization={handleSwitchOrganizationClick}
                        onSearchStateChange={handleSearchStateChange}
                        onSearchSubmit={handleSearchOnSubmit}
                        notificationViewInfo={notificationViewInfo}
                        isSearchDisabled={searchViewInfo.isPreloading}
                    />

                    <div className="row">
                        {
                            mainContentView === MainContentViews.NewsfeedResults &&
                            (<Newsfeed newsfeedViewInfo={newsfeedViewInfo}
                                       organizationPlaceholders={_sessionResponse.current.organizationPlaceholders}
                                       onReadMore={handleReadMore}
                                       onDismiss={handleDismiss}
                                       onClickRefreshNewsfeed={handleRefreshNewsfeed}
                                       organizationIcon={selectedOrganization.current?.organizationIcon}
                            />)
                        }

                        {
                            mainContentView === MainContentViews.SearchResults &&
                            (<Search searchViewInfo={searchViewInfo}
                                     organizationPlaceholders={_sessionResponse.current.organizationPlaceholders}
                                     onReadMore={handleReadMore}
                                     onDismiss={handleDismiss}
                                     organizationIcon={selectedOrganization.current?.organizationIcon}
                            />)
                        }

                        {
                            (newsfeedViewInfo.isPreloading || searchViewInfo?.isPreloading) &&
                            (
                                <div className="smt-flex preloader"/>
                            )
                        }
                    </div>

                    {renderSwitchOrganizationDrawer()}
                    {renderNotificationDrawer()}
                </Fragment>
            );
        } else if (currentView === TabViews.REQUIRE_CONSENT) {
            currentViewRender = (
                <div className="smt-flex smt-flex__gap-1 smt-flex__dir_column smt-flex__ai-center smt-flex__jc-center">
                    <Text size={400} weight="semibold">Cerkl Broadcast and Microsoft Teams</Text>
                    <Text size={200}>Verify your identity to get started with Cerkl Broadcast</Text>
                    <Button size="medium" onClick={handleConsentClick} appearance="primary">Get Started</Button>
                </div>
            );
        } else if (currentView === TabViews.LOADING) {
            currentViewRender = (
                <div className="smt-flex smt-flex__ai-center smt-flex__jc-center smt-filled" style={{position: "fixed"}}>
                    <div className="smt-flex smt-flex__dir_column">
                        <Spinner/>
                        <Text>Your newsfeed is loading...</Text>
                    </div>

                </div>

            );
        } else if (currentView === TabViews.USER_DOES_NOT_HAVE_EMAIL) {
            currentViewRender = (
                <div className="smt-flex smt-flex__ai-center smt-flex__jc-center smt-flex__dir_column smt-flex__gap-1" >
                    <Text size={400} weight="semibold">We're sorry</Text>
                    <Text size={200}>We cannot identify you without an email attached to your account.</Text>
                </div>
            );
        } else if (currentView === TabViews.USER_NOT_IN_SYSTEM_ORG_NOT_SUPPORT_TEAMS) {
            currentViewRender = (
                <div className="smt-flex smt-flex__ai-center smt-flex__jc-center smt-flex__dir_column smt-flex__gap-1" >
                    <Text size={400} weight="semibold">We're sorry</Text>
                    <Text size={200}>Your email must be associated with an active Broadcast Premier or Ultimate subscription to use this app. If this is an error, contact support@cerkl.com. If you'd like to learn how you can use Cerkl Broadcast to communicate across channels, request a demo.</Text>
                    <div className="smt-flex smt-flex__gap-1">
                        <Button size="medium" onClick={() => {
                            window.open('https://cerkl.com/demo/', "_blank");
                        }} appearance="primary">Request a Demo</Button>
                        <Button size="medium" onClick={() => {
                            window.open('https://cerkl.com/contact', "_blank");
                        }}>Contact Us</Button>
                    </div>

                </div>
            );
        } else if (currentView === TabViews.UNKNOWN_ERROR) {
            currentViewRender = (
                <div className="smt-flex smt-flex__ai-center smt-flex__jc-center smt-flex__dir_column smt-flex__gap-1" >
                    <Text size={400} weight="semibold">Something went wrong</Text>
                    <Text size={200}>
                        Please refresh and try again. If the problem persists, visit <a
                        href="https://help.cerkl.com">help.cerkl.com</a>
                    </Text>
                    <Button size="medium" onClick={() => {
                        window.location.reload();
                    }} appearance="primary">Refresh</Button>
                </div>
            );
        }
        return currentViewRender;
    }
    return render();
}
